module.exports = __webpack_public_path__ + "img/left-logo.0ad8ed97.png";